<template>
  <div class="score-form-p" v-show="scoreFormIsShow">
    <div class="mask-p"></div>
    <div class="form-box-p">
      <div class="close-p" @click="toggle"></div>
      <ul>
        <li v-for="(item,index) of value" :key="index" class="score-item-p">
          <p>{{item.option}}</p>
          <input type="text" :placeholder="'满分'+item.totalScore" maxlength="2" v-model="item.score" />
        </li>
      </ul>
      <div class="score-btn-p">
        <p @click="reset">重置</p>
        <p @click="create">确定</p>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/createQE/scoreForm.scss"

export default {
  name: 'scoreForm',
  data() {
    return {
      scoreFormIsShow: false,
    }
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    toggle() {
      this.scoreFormIsShow = !this.scoreFormIsShow
      // this.$emit("scoreTableShow")
    },
    create() {
      for (let i = 0; i < this.value.length; i++) {
        let reg = /^\d{1,2}$/
        if (!reg.test(this.value[i].score)) {
           this.$layer.alert("请输入正确的评分!")
           return
        }
        if (this.value[i].score > this.value[i].totalScore) {
           this.$layer.alert(`[${this.value[i].option}]不能超过${this.value[i].totalScore}分!`)
           return
        }
      }
      this.scoreFormIsShow = false
      this.$emit("scoreTableShow")
    },
    reset() {
      this.value.forEach(item => {
        item.score = ""
      })
    }
  },
  mounted() {

  }
}
</script>